/* Epic — "Request a call": the header button, its dialog, and sending the
   form in place. Validation and the field states are epic-form.js. */
(() => {
  const params = new URLSearchParams(location.search);

  function init() {
    document.querySelectorAll('[data-epic-call]').forEach((dlg) => {
      if (dlg.dataset.wired) return;
      dlg.dataset.wired = '1';
      const form = dlg.querySelector('form');
      const fields = dlg.querySelector('[data-call-fields]');
      const okTpl = dlg.querySelector('[data-call-oktpl]');
      let lastFocus = null;

      const open = () => {
        lastFocus = document.activeElement;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        const first = dlg.querySelector('[data-call-fields]:not([hidden]) input:not([type=hidden])');
        if (first) setTimeout(() => first.focus(), 60);
      };
      const close = () => { dlg.close ? dlg.close() : dlg.removeAttribute('open'); };
      dlg.addEventListener('close', () => { if (lastFocus && lastFocus.focus) lastFocus.focus(); });

      document.querySelectorAll(`[aria-controls="${dlg.id}"][data-epic-call-open]`).forEach((b) => b.addEventListener('click', open));
      dlg.querySelectorAll('[data-epic-call-close]').forEach((b) => b.addEventListener('click', close));
      // A click on the backdrop (the dialog element itself, outside its box) closes it.
      dlg.addEventListener('click', (e) => {
        if (e.target !== dlg) return;
        const r = dlg.getBoundingClientRect();
        const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) close();
      });

      // Back from a post of THIS form (Shopify returns ?contact_posted=true
      // with the form's id as the hash), or from an error on it: reopen.
      const ours = location.hash === '#EpicCall' || location.hash === `#${form && form.id}`;
      const okNow = dlg.querySelector('[data-call-ok]');
      if (okNow && !ours) {
        // Shopify marks every contact form on the page as posted after any
        // one of them is sent; this was another form, so show ours fresh.
        okNow.remove();
        if (fields) fields.hidden = false;
      }
      if (ours && (params.get('contact_posted') === 'true' || dlg.querySelector('.epic-fm__err'))) open();

      // No AJAX send. The live store runs Shopify's spam protection (hCaptcha)
      // on contact forms, which hooks the browser's own submit to fetch a
      // token first; posting with fetch() skipped that and the request was
      // refused with a captcha error. A normal submit lets Shopify finish its
      // check, and the page comes back to #EpicCall with contact_posted=true,
      // which the code above turns into the dialog's success state.
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
